import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MasterInquireApiResponse, MASTER_INQUIRE_INIT } from '../types/api/MasterInquireApiType';

// お問い合わせ種別、お問い合わせ理由のマスタ管理
const slice = createSlice({
    name: 'MasterInquireData',
    // 初期値
    initialState: MASTER_INQUIRE_INIT,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<MasterInquireApiResponse>) => action.payload,
        // 初期化
        initState: () => MASTER_INQUIRE_INIT,
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
